var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{ref:"modal",attrs:{"title":'Deletar ' + _vm.name,"name":"Delete","okTitle":"Deletar","okVariant":"danger","cancelVariant":"secondary"},on:{"ok":_vm.submit}},[_c('p',[_vm._v("Tem certeza que deseja deletar "+_vm._s(_vm.state.name)+"?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }